/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const RepatriationOpportunityQuoteStatusResource = {
    Created: 'CREATED',
    Accepted: 'ACCEPTED',
    Canceled: 'CANCELED',
    Expired: 'EXPIRED'
} as const;
export type RepatriationOpportunityQuoteStatusResource = typeof RepatriationOpportunityQuoteStatusResource[keyof typeof RepatriationOpportunityQuoteStatusResource];


export function instanceOfRepatriationOpportunityQuoteStatusResource(value: any): boolean {
    for (const key in RepatriationOpportunityQuoteStatusResource) {
        if (Object.prototype.hasOwnProperty.call(RepatriationOpportunityQuoteStatusResource, key)) {
            // @ts-ignore
            if (RepatriationOpportunityQuoteStatusResource[key] === value) {
                return true;
            }
        }
    }
    return false;
}

export function RepatriationOpportunityQuoteStatusResourceFromJSON(json: any): RepatriationOpportunityQuoteStatusResource {
    return RepatriationOpportunityQuoteStatusResourceFromJSONTyped(json, false);
}

export function RepatriationOpportunityQuoteStatusResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): RepatriationOpportunityQuoteStatusResource {
    return json as RepatriationOpportunityQuoteStatusResource;
}

export function RepatriationOpportunityQuoteStatusResourceToJSON(value?: RepatriationOpportunityQuoteStatusResource | null): any {
    return value as any;
}

